import config from '../config';
import fetch from 'cross-fetch';
import store from 'store2';
import {
    loadAllTasks,
    loadDetailsWithoutProperty,
    loadDetailsByBoardId,
    loadTasksWithoutPosition,
    loadTaskClocks,
    revertTaskAssignmentByTaskId,
    setTaskPositionByTaskIdAndPosition,
    sendEmailByTaskIdAndStageId,
    archivedByTaskId,
    loadDetailProjectTask
} from '../actions/dashboard';
import { addNotification as notify } from 'reapop';
import { deleteTaskById } from "../actions/tasks";
import { push } from "react-router-redux";

export function fetchAllTasks() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/dashboard/tasks`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadAllTasks(json));
          }
        })
    }
  }
}

export function getDetailProjectTask(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/project/getDetailsProjectTask/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadDetailProjectTask(json));
          }
        })
    }
  }
}

export function fetchDetails() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/dashboard/details/filtered`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            // Cache lanes and stages
            dispatch(loadDetailsWithoutProperty(json));
          }
        })
    }
  }
}
export function fetchDetailsWithoutProperty() {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/dashboard/details`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              // Cache lanes and stages
              dispatch(loadDetailsWithoutProperty(json));
            }
          })
      }
    }
}

export function fetchDetailsByBoardId(data) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/dashboard/details?board_id=${data.id}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(loadDetailsByBoardId(json));
            }
          })
      }
    }
}

export function fetchTasksWithoutPosition() {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/dashboard/getTasksWoPosition`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(loadTasksWithoutPosition(json));
            }
          })
      }
    }
}

export function fetchTaskClocks() {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/dashboard/getTaskClocks`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(loadTaskClocks(json));
            }
          })
      }
    }
}

export function reverseTaskAssignmentByTaskId(data) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/dashboard/revertTaskAssignment`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(revertTaskAssignmentByTaskId(json));
            }
          })
      }
    }
}

export function adjustTaskPositionByTaskIdAndPosition(data) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/dashboard/setTaskPosition`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              if (json.email === true) {
                dispatch(notify({
                  title: 'Email Notification',
                  message: 'Notification sent successfully.',
                  status: 'success',
                  position: 'tr',
                  dismissible: true,
                  dismissAfter: 3000
                }));
              }

              dispatch(setTaskPositionByTaskIdAndPosition({
                task_id: data.task_id,
                stage_id: json.stage_id,
              }));
            }
          })
      }
    }
}

export function transferEmailByTaskIdAndStageId(data) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/dashboard/sendEmail`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              if (json.email) {
                dispatch(notify({
                  title: 'Email Notification',
                  message: 'Notification sent successfully',
                  status: 'success',
                  position: 'tr',
                  dismissible: true,
                  dismissAfter: 3000
                }));
              }
              dispatch(sendEmailByTaskIdAndStageId(json));
            }
          })
      }
    }
}

export function storedByTaskId(data) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/dashboard/archive`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(archivedByTaskId(json));
            }
          })
      }
    }
}

export function deleteWOById(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if ( userAuth && userAuth.api_token ) {
      return fetch(`${config.apiEndpoint}/task/${data.id}`, {
        method: 'DELETE',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if ( json ) {
            dispatch(deleteTaskById({ id: data.id }));
            dispatch(notify({
              title: 'Delete work order',
              message: 'Work order deleted successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
            setTimeout(() => {}, 1500)
          }
          dispatch(push(data.redirect ? data.redirect : '/pages/dashboards'));
        })
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/dashboard.js